var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import PlusIcon from '../atoms/PlusIcon';
import React, { useRef, useState } from 'react';
import { s3, ryanAI } from '../../helpers/awsConfig';
import removeBackground from '../../helpers/removeBackground';
import ToolsContainer from './ToolsContainer';
import ActiveIcon from '../atoms/ActiveIcon';
import InActiveIcon from '../atoms/InActiveIcon';
const ImagesContainer = React.memo(({ imageState, imageToolsRef, strings, selectedImage, maxUploadsCount, uploadedImagesCount, cutOutInitial, maxFileSize, maxDims, minDims, sessionID, dailyFolderName, bucketName, showCutOutToggle, useRyanAI, handleImageUpload, removeImageFromS3, setSelectedImage, setImageLoading, handleLayerChange, handleToolClick, templateCopy, }) => {
    const fileInputRef = useRef(null);
    const [cutOutOn, setCutOutOn] = useState(cutOutInitial);
    const MAX_DIMENSION = maxDims ? Number(maxDims) : 5000;
    const MIN_DIMENSION = minDims ? Number(minDims) : 300;
    const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];
    const MAX_FILE_SIZE_MB = maxFileSize ? Number(maxFileSize) : 6; // in MB
    const MAX_WIDTH = 1200;
    const MAX_HEIGHT = 1200;
    const FILE_TYPE = 'webp'; // Force WebP format
    const handleToggle = () => {
        const newState = !cutOutOn;
        setCutOutOn(newState);
    };
    const checkImageSize = (height, width, freeImageIndex) => {
        if (height > MAX_DIMENSION || width > MAX_DIMENSION) {
            handleImageUpload(null, null, null, 'fileLarge', freeImageIndex);
            return false;
        }
        else if (height < MIN_DIMENSION || width < MIN_DIMENSION) {
            handleImageUpload(null, null, null, 'fileSmall', freeImageIndex);
            return false;
        }
        return true;
    };
    const compressAndUploadImage = (img, uid, freeImageIndex, cutOutEnabled) => __awaiter(void 0, void 0, void 0, function* () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        let { width, height } = img;
        // Resize logic
        if (width > height && width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
        }
        else if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        // Convert to blob
        const blob = yield new Promise((resolve) => canvas.toBlob(resolve, `image/png`, 1));
        if (!blob)
            return;
        // @ts-ignore
        if (cutOutEnabled) {
            if (useRyanAI) {
                // hit ryan endpoint
                try {
                    yield ryanAI(blob, sessionID).then((imageURL) => __awaiter(void 0, void 0, void 0, function* () {
                        const img = new Image();
                        img.src = imageURL;
                        img.onload = () => __awaiter(void 0, void 0, void 0, function* () {
                            const imageHeight = img.height;
                            const imageWidth = img.width;
                            handleImageUpload(imageURL, imageHeight, imageWidth, '', freeImageIndex);
                        });
                    }));
                }
                catch (error) {
                    console.error('THREADHEADS: RyanAI Cutout Error', error.message);
                    handleImageUpload(null, null, null, 'backgroundCutoutError', freeImageIndex);
                }
            }
            else {
                try {
                    yield removeBackground(blob)
                        .then((imageData) => __awaiter(void 0, void 0, void 0, function* () {
                        function arrayBufferToBase64(buffer) {
                            let binary = '';
                            const bytes = new Uint8Array(buffer);
                            const len = bytes.byteLength;
                            for (let i = 0; i < len; i++) {
                                binary += String.fromCharCode(bytes[i]);
                            }
                            return btoa(binary);
                        }
                        return arrayBufferToBase64(imageData);
                    }))
                        .then((base64Image) => __awaiter(void 0, void 0, void 0, function* () {
                        const img = new Image();
                        img.src = 'data:image/png;base64,' + base64Image;
                        img.onload = () => __awaiter(void 0, void 0, void 0, function* () {
                            const imageHeight = img.height;
                            const imageWidth = img.width;
                            const imageBuffer = Buffer.from(base64Image.replace(/^data:image\/\w+;base64,/, ''), 'base64');
                            yield uploadToS3(imageBuffer, `${uid}.png`, 'image/png', freeImageIndex, imageHeight, imageWidth);
                        });
                    }));
                }
                catch (error) {
                    console.error('THREADHEADS: Background Cutout Error', error.message);
                    handleImageUpload(null, null, null, 'backgroundCutoutError', freeImageIndex);
                }
            }
        }
        else {
            yield uploadToS3(blob, `${uid}.${FILE_TYPE}`, `image/${FILE_TYPE}`, freeImageIndex, height, width);
        }
    });
    const uploadToS3 = (body, fileName, contentType, freeImageIndex, height, width) => __awaiter(void 0, void 0, void 0, function* () {
        const uploadParams = {
            Bucket: bucketName,
            Key: `assets/${dailyFolderName}/${sessionID}/uploaded-images/${fileName}`,
            Body: body,
            ContentType: contentType,
            ACL: 'public-read',
        };
        try {
            const data = yield s3.upload(uploadParams).promise();
            console.log('THREADHEADS: Upload Success');
            handleImageUpload(data.Location, height, width, '', freeImageIndex);
        }
        catch (error) {
            console.error('THREADHEADS: Upload Error', error.message);
            handleImageUpload(null, null, null, 'uploadError', freeImageIndex);
        }
    });
    const processImage = (file, freeImageIndex, cutOutEnabled) => __awaiter(void 0, void 0, void 0, function* () {
        const reader = new FileReader();
        const uid = `${Date.now().toString(36)}${Math.random().toString(36).substr(2)}`;
        reader.onload = (e) => {
            const img = new Image();
            // @ts-ignore
            img.src = e.target.result;
            img.onload = () => __awaiter(void 0, void 0, void 0, function* () {
                const { height, width } = img;
                // Check size validity
                if (!checkImageSize(height, width, freeImageIndex))
                    return;
                // Compress and upload image
                yield compressAndUploadImage(img, uid, freeImageIndex, cutOutEnabled);
            });
        };
        reader.readAsDataURL(file);
    });
    const uploadIndividualImage = (file, freeImageIndex) => __awaiter(void 0, void 0, void 0, function* () {
        if (!file)
            return;
        // Validate file type
        if (!ALLOWED_TYPES.includes(file.type)) {
            handleImageUpload(null, null, null, 'fileType', freeImageIndex);
            return;
        }
        // Validate file size
        if (file.size / (1024 * 1024) > MAX_FILE_SIZE_MB) {
            handleImageUpload(null, null, null, 'fileSize', freeImageIndex);
            return;
        }
        // Process and upload image
        yield processImage(file, freeImageIndex, cutOutOn);
    });
    const handleFileChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        const files = Array.from(event.target.files);
        const freeImageSlots = imageState.images.filter((item) => item.uploadedImage == null && item.loading === false);
        const uploadTasks = freeImageSlots.slice(0, files.length).map((slot, index) => {
            const fileToUpload = files[index];
            if (fileToUpload) {
                const freeImageIndex = slot.initialIndex;
                setImageLoading(freeImageIndex);
                return uploadIndividualImage(fileToUpload, freeImageIndex);
            }
        });
        yield Promise.all(uploadTasks);
        event.target.value = ''; // Reset the input after file selection
    });
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const setImage = (initialIndex) => {
        setSelectedImage(initialIndex);
    };
    return (React.createElement("div", { className: "th-c-images" },
        React.createElement("div", { className: "th-c-images__header" },
            React.createElement("h3", { className: "th-customiser__section-title" }, strings.images_title),
            React.createElement("p", { className: "description__count" },
                React.createElement("span", null, uploadedImagesCount),
                React.createElement("span", null, "/"),
                imageState.images.length)),
        React.createElement("div", { className: "th-c-images__description" }, showCutOutToggle ? (React.createElement("div", { className: "description__cutout-toggle" },
            React.createElement("div", { className: `toggle-switch-slider ${cutOutOn ? 'active' : ''}`, onClick: handleToggle, role: "button", "aria-pressed": cutOutOn, tabIndex: 0 },
                React.createElement("div", { className: "toggle-switch-thumb" },
                    React.createElement(ActiveIcon, null),
                    React.createElement(InActiveIcon, null))),
            React.createElement("span", null, strings.cut_out_toggle),
            templateCopy.th_c_cutout_toolip && (React.createElement("div", { className: "cutout-toggle__tooltip" },
                React.createElement("svg", { className: "tooltip__toggle", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Info icon", focusable: "false", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
                    React.createElement("path", { d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "#CAC9D6" })),
                React.createElement("div", { className: "tooltip__content" },
                    React.createElement("p", null, templateCopy.th_c_cutout_toolip)))))) : (React.createElement("p", { className: "th-c-images__description--text" }, strings.image_upload_message))),
        React.createElement("div", { className: "th-c-images__uploads-container" },
            imageState.images.map((imageItem, index) => {
                return imageItem.loading ? (React.createElement("div", { className: "th-c-images__upload-tile th-c-images__upload-tile--loading", key: index },
                    React.createElement("div", { className: "loader" }))) : imageItem.uploadedImage != null ? (React.createElement("div", { className: `th-c-images__upload-tile ${imageItem.initialIndex == selectedImage ? 'is-selected' : ''}`, key: index, onClick: () => setImage(imageItem.initialIndex) },
                    React.createElement("button", { className: "th-c-images__upload-tile--delete", onClick: () => removeImageFromS3(imageItem.initialIndex, imageItem.uploadedImage) },
                        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14", fill: "none" },
                            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.263868 0.263868C0.615691 -0.0879559 1.18611 -0.0879559 1.53793 0.263868L13.7361 12.4621C14.088 12.8139 14.088 13.3843 13.7361 13.7361C13.3843 14.088 12.8139 14.088 12.4621 13.7361L0.263868 1.53793C-0.0879559 1.18611 -0.0879559 0.615691 0.263868 0.263868Z", fill: "white" }),
                            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7361 0.263868C14.088 0.615691 14.088 1.18611 13.7361 1.53793L1.53793 13.7361C1.18611 14.088 0.615691 14.088 0.263868 13.7361C-0.0879559 13.3843 -0.0879559 12.8139 0.263868 12.4621L12.4621 0.263868C12.8139 -0.0879559 13.3843 -0.0879559 13.7361 0.263868Z", fill: "white" }))),
                    React.createElement("div", { className: "th-c-images__upload-tile--wrapper" },
                        React.createElement("img", { className: "th-c-images__upload-tile--image", src: imageItem.uploadedImage })))) : null;
            }),
            uploadedImagesCount < imageState.order.length && (React.createElement("div", { className: "th-c-images__upload-tile th-c-images__upload-tile--placeholder", onClick: handleButtonClick },
                React.createElement(PlusIcon, null)))),
        React.createElement("button", { className: "th-customiser__solid-rounded-btn", onClick: handleButtonClick, disabled: uploadedImagesCount == maxUploadsCount },
            React.createElement(PlusIcon, null),
            React.createElement("span", null, strings.image_upload_btn)),
        React.createElement("input", { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleFileChange, style: { display: 'none' }, multiple: true }),
        selectedImage != null && (React.createElement("div", { ref: imageToolsRef },
            React.createElement(ToolsContainer, { extraClass: "th-c-tools--mobile-only", strings: strings, handleToolClick: handleToolClick, handleLayerChange: handleLayerChange, disabled: selectedImage == null })))));
});
export default ImagesContainer;
